
import { Heart } from 'lucide-react';
import { CategoryConfig } from '@/types/category';
import { QuestionConfig } from '@/components/questionnaire/types';
import { zenAfLanguageConfig } from './zenAfLanguageRules';

export const explicitMeditationConfig: CategoryConfig = {
  name: 'ZEN AF',
  color: 'from-red-500 to-red-700',
  icon: Heart,
  defaultPrompt: `Create a completely original therapeutic meditation session using raw, authentic language that's personally crafted for this individual. Generate unique explicit expressions based on their specific life situation, work stress, relationships, and personal challenges. Use therapeutic profanity to validate their actual frustrations, target their real external stressors (never their self-worth), and build personalized empowerment language. Create original metaphors from their biographical details rather than using any preset examples or templates. Every raw expression should feel authentically relevant to their unique experience and serve their specific healing needs.`,
  samplePrompt: 'Create a personalized meditation session that uses raw language therapeutically. Validate their specific frustrations with authentic explicit language, help them release stress by targeting external problems, and guide them to empowerment. Build original metaphors from their actual life details rather than generic examples.',
  description: 'Raw, explicit meditation for releasing frustration and stress (18+ only)',
  requiresAgeVerification: true,
  questions: {
    specificFocus: {
      label: "What's bothering you today?",
      type: 'textarea',
      placeholder: 'Tell me what\'s really getting to you right now...'
    },
    triggers: {
      label: 'Why?',
      type: 'textarea',
      placeholder: 'What\'s the deeper reason this is affecting you?'
    }
  },
  presetMeditations: []
};
